import { MessageService } from 'primeng/components/common/messageservice';

import { BadInputError } from './errors/bad-input-error';
import { UnknownUrlError } from './errors/unknown-url-error';

export class WebPage {

  protected isLoading = false;

  constructor(protected messageService: MessageService) { }

  stopLoading() {

    this.isLoading = false;

  }

  playLoading() {

    this.isLoading = true;

  }

  gerenciaErro(error) {

    switch (error) {
      case error instanceof BadInputError:
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: error.message });
        break;
      case error instanceof UnknownUrlError:
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao acessar a API. Por favor, contate nosso suporte.' });
      default:
        throw error;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/web-page.ts